export default "__VITE_ASSET__B1J1d2r1__"